<template lang='pug' src='./technologies.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/Hero/Hero'
import HeadBar from 'components/block/block-text-header/block-text-header'
import TextBox from 'components/block/block-text-box/block-text-box'
import Icon from 'components/icon/icon'
import CustomText from 'components/custom/custom-text-image/custom-text-image'

export default {
  name: 'technologies',
  computed: {
    props () {
      return this.$store.state.pages.technologies
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Hero,
    HeadBar,
    TextBox,
    Icon,
    CustomText
  }
}
</script>



// WEBPACK FOOTER //
// technologies.vue?9867fc6c